import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9 2H1V21H2C4.94416 21 7.13918 21.2453 8.5856 21.4864C9.30891 21.6069 9.84535 21.7265 10.195 21.8139C10.3698 21.8576 10.4979 21.8933 10.5794 21.917C10.6201 21.9289 10.6492 21.9378 10.6666 21.9432L10.6838 21.9487L10.6847 21.949L10.686 21.9494L10.8377 22H13.1623L13.314 21.9494L13.3162 21.9487L13.3334 21.9432C13.3508 21.9378 13.3799 21.9289 13.4206 21.917C13.5021 21.8933 13.6302 21.8576 13.805 21.8139C14.1546 21.7265 14.6911 21.6069 15.4144 21.4864C16.8608 21.2453 19.0558 21 22 21H23L23 2H15C13.8053 2 12.7329 2.52376 12 3.35418C11.2671 2.52375 10.1947 2 9 2ZM3 19.0093V4H9C10.1046 4 11 4.89543 11 6V19.9575C10.9117 19.9332 10.805 19.9049 10.68 19.8736C10.2796 19.7735 9.69108 19.6431 8.9144 19.5136C7.53508 19.2837 5.56349 19.0572 3 19.0093ZM16 10.5V11.5H14V10.5C14 8.84315 15.3431 7.5 17 7.5C18.6569 7.5 20 8.84315 20 10.5C20 11.1761 19.8282 11.7459 19.5259 12.2099C19.2288 12.6659 18.8429 12.9631 18.4972 13.1603C18.3243 13.2589 18.1536 13.3366 18.0034 13.3975V13.75H16.0034V12.75C16.0034 12.3263 16.2481 12.0627 16.3644 11.9601C16.4836 11.855 16.6042 11.7949 16.6602 11.7683C16.7666 11.7177 16.8935 11.6738 16.9686 11.6478L16.9869 11.6414C17.1775 11.5751 17.3462 11.5143 17.5062 11.423C17.6597 11.3355 17.7729 11.2368 17.8501 11.1182C17.9223 11.0075 18 10.8239 18 10.5C18 9.94772 17.5523 9.5 17 9.5C16.4477 9.5 16 9.94772 16 10.5ZM18.0039 14.5V16.5039H16V14.5H18.0039Z"}}]};

const BookUnknownFilled = Vue.extend<IconProps>({
  name: 'BookUnknownFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'book-unknown-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default BookUnknownFilled;
